import { render } from "./Infotec.vue?vue&type=template&id=af5ab814"
const script = {}

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__